<template>
  <div class="service-course" v-if="loading">
    <div class="content container box">
      <com-h1 title="技术会议推荐" title-en="8000+技术团队共同的选择"></com-h1>
      <div class="course-list">
        <v-touch class="animation-wrapper" :swipe-options="{ direction: 'horizontal' }" @swipeleft="nextCourse" @swiperight="prevCourse">
          <div class="timeline-wrap" :style="{width: 160 * (course.length - 1) + 290 + 'px', transform: 'translateX(-' + leftPosition + ')'}">
            <a :href="item.link ? item.link : 'javascript:;'" :title="item.link ? item.title : item.title" :target="item.link ? '_blank' : '_self'" :class="[item.className, {on: courseChoosed === index}]" v-for="(item, index) in course" :key="index">
              <i class="before" :style="{backgroundImage: `url(${item.logo})`}"></i>
              <i class="after" :style="{backgroundImage: `url(${item.logo})`}"></i>
              <div class="ball"></div>
            </a>
          </div>
        </v-touch>
      </div>
      <div class="operation">
        <div class="prev" @click="prevCourse"></div>
        <div class="next" @click="nextCourse"></div>
        <h6>
          <span v-if="!isMobile">{{`${course[courseChoosed].preTitle} `}}</span>
          <span v-html="course[courseChoosed].title"></span>
          <span v-html="course[courseChoosed].preTitle" v-if="!isMobile && course[courseChoosed].multipleTitle"></span>
          <span v-html="course[courseChoosed].multipleTitle"></span>
          <a v-for="(info, key) in course[courseChoosed].info" class="info" :key="key" :href="info.link||'javascript:;'" :title="info.link ? course[courseChoosed].title + '·' + info.area : '敬请期待'">
            <span class="area">{{info.area}}</span>
            <span class="area-info">
              <span class="training" v-if="info.trainingBegin&&isPre(info.trainingBegin, info.meetingBegin)">培训：{{format(info.trainingBegin, info.trainingEnd)}}</span>
              <span class="meeting" v-if="info.meetingBegin">会议：{{format(info.meetingBegin, info.meetingEnd)}}</span>
              <span class="training" v-if="info.trainingBegin&&isPre(info.meetingBegin, info.trainingBegin)">培训：{{format(info.trainingBegin, info.trainingEnd)}}</span>
            </span>
            <span class="arrow"><i></i></span>
          </a>
          <span class="scope">领域：{{course[courseChoosed].scope}}</span>
        </h6>
      </div>

    </div>
  </div>
</template>

<script>

import comH1 from 'gkConUI/com-h1/title2.vue'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
    comH1
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      courseChoosed: 0,
      isMove: false,
      course: []
    }
  },
  computed: {
    leftPosition () {
      return 160 * this.courseChoosed + 'px'
    },
    hostname () {
      return window.location.hostname
    }
  },
  watch: {},
  created () {
    this.loading = false
    // 公共大会后台读取全年会议推荐信息
    axios.get('https://static-data.geekbang.org/common1/data.json').then(
      res => {
        this.course = res.data.info.recommend
        this.loading = true

        this.course.forEach((item, index) => {
          if (this.hostname.indexOf(item.preTitle.toLowerCase()) > -1) {
            this.courseChoosed = index
          }
        })
      }
    )
  },
  mounted () {
  },
  methods: {
    /**
     * 选择上一个公开课
     */
    prevCourse () {
      this.courseChoosed > 0 && this.courseChoosed--
    },
    /**
     * 选择下一个公开课
     */
    nextCourse () {
      this.courseChoosed < this.course.length - 1 && this.courseChoosed++
    },
    format (begin, end) {
      let time = ''
      if (Date.parse(end) - Date.parse(begin) > 60 * 60 * 24 * 1000) {
        time = moment(begin).format('YYYY年MM月DD') + '-' + moment(end).format('DD日')
      } else {
        time = moment(begin).format('YYYY年MM月DD日')
      }
      return time
    },
    isPre (t1, t2) {
      return moment(t1).isBefore(t2)
    }
  }
}
</script>

<style lang="scss" scoped>
  $timeline: $grey-lighter;

  .service-course {
    padding:0 0 25px;
    background: $white;

    & .course-list {
      position: relative;
      height: 113px;
      margin-top: -10px;
      border-bottom: 2px solid $timeline;

      li {
        list-style: none;
      }

      &:before,
      &:after {
        content: ' ';
        display: block;
        position: absolute;
        bottom: -2px;
        width: 100px;
        height: 2px;
      }

      &:before {
        left: 0;
        background: linear-gradient(to left, $timeline, $grey-lighter);
      }

      &:after {
        right: 0;
        background: linear-gradient(to right, $timeline, $grey-lighter);
      }

      & .animation-wrapper {
        position: relative;
        z-index: 1;
        overflow: hidden;
        width: 100%;
        height: 130px;

        &:before,
        &:after {
          content: ' ';
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          z-index: 1;
          width: 150px;
        }

        &:before {
          left: -2px;
          background: linear-gradient(to left, rgba(245, 245, 245, 0), rgba(255, 255, 255, 1));
        }

        &:after {
          right: -2px;
          background: linear-gradient(to right, rgba(245, 245, 245, 0), rgba(255, 255, 255, 1));
        }
      }

      & .timeline-wrap {
        position: absolute;
        left: 50%;
        top: 0;
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        margin-left: -145px;
        transition: all 0.5s ease;
        transform: translateZ(0);

        & a:hover {
          cursor: default;
        }

        & a {
          position: relative;
          width: 160px;
          height: 100%;
          transition: all 0.5s ease;

          & .before,
          & .after {
            // content: ' ';
            display: block;
            position: absolute;
            left: 50%;
            top: 0;
            width: 160px;
            height: 90px;
            margin-left: -80px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 160px 67px;
            transform: translateZ(0);
            transition: all 0.5s ease;
          }

          // &.aicon {
          //   & .before {
          //     background-image: url('./assets/course-logo-aicon-normal.png');
          //   }

          //   & .after {
          //     background-image: url('./assets/course-logo-aicon-normal.png');
          //   }
          // }

          // &.qcon {
          //   &:before {
          //     background-image: url('./assets/course-logo-qcon-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-qcon-normal.png');
          //   }
          // }

          // &.gtlc {
          //   &:before {
          //     background-image: url('./assets/course-logo-gtlc-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-gtlc-normal.png');
          //   }
          // }

          // &.gmtc {
          //   &:before {
          //     background-image: url('./assets/course-logo-gmtc-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-gmtc-normal.png');
          //   }
          // }

          // &.archsummit {
          //   &:before {
          //     background-image: url('./assets/course-logo-archsummit-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-archsummit-normal.png');
          //   }
          // }

          // &.bccon {
          //   &:before {
          //     background-image: url('./assets/course-logo-bccon-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-bccon-normal.png');
          //   }
          // }

          // &.cnut {
          //   &:before {
          //     background-image: url('./assets/course-logo-cnut-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-cnut-normal.png');
          //   }
          // }

          // &.pcon {
          //   &:before {
          //     background-image: url('./assets/course-logo-pcon-normal.png');
          //   }

          //   &:after {
          //     background-image: url('./assets/course-logo-pcon-normal.png');
          //   }
          // }

          & .after {
            opacity: 0;
          }

          & .ball {
            box-sizing: border-box;
            position: absolute;
            left: 50%;
            bottom: 11px;
            width: 14px;
            height: 14px;
            margin-left: -7px;
            background: #FFF;
            border: 2px solid $grey-lighter;
            border-radius: 14px;
            &:before,
            &:after {
              content: ' ';
              display: block;
              position: absolute;
              left: 50%;
              top: 50%;
              z-index: 10;
              transform: scale(0);
              transition: all 0.2s ease;
            }

            &:before {
              width: 32px;
              height: 32px;
              margin: -16px 0 0 -16px;
              background: var(--primary-color);
              border-radius: 32px;
            }

            &:after {
              width: 14px;
              height: 14px;
              margin: -7px 0 0 -7px;
              background: var(--primary-color);
              border-radius: 20px;
            }
          }

          &.on {
            width: 290px;

            & .before,
            & .after {
              transform: scale(1.6) translateY(-7px);
            }

            & .before {
              opacity: 0;
            }

            & .after {
              opacity: 1;
            }

            & .ball {
              background: transparent;
              border-color: transparent;

              &:before {
                animation: loopScale 2s infinite linear;
              }

              &:after {
                transform: scale(1);
              }
            }
          }
        }
      }
    }

    & .operation {
      position: relative;
      width: 655px;
      padding: 10px 0 60px;
      margin: 0 auto;
      /*border-bottom: 2px solid #E6E6E6;*/

      & .prev,
      & .next {
        position: absolute;
        top: 50%;
        width: 36px;
        height: 72px;
        /*background: #EEE;*/
        border-radius: 3px;
        transform: translateY(-50%);
        transition: all 0.3s ease;
        cursor: pointer;

        &:before {
          content: ' ';
          display: block;
          position: absolute;
          left: 0;
          top: 50%;
          width: 26px;
          height: 26px;
          border-top: 2px solid #c8c8c8;
        }

        &:hover:before {
          border-color: #999;
        }
      }

      & .prev {
        left: 0;

        &:before {
          border-left: 2px solid #c8c8c8;
          transform: translate(14px, -50%) rotate(-45deg);
        }
      }

      & .next {
        right: 0;

        &:before {
          border-right: 2px solid #c8c8c8;
          transform: translate(-4px, -50%) rotate(45deg);
        }
      }

      & > h6 {
        height: 115px;
        padding: 10px 0 20px;
        line-height: 32px;
        text-align: center;
        font-size: 24px;
        color: var(--primary-color);
      }

      & .info:first-of-type{
        margin-top: 25px;
      }

      & .info {
        width: 480px;
        display: block;
        line-height: 1.5;
        text-align: center;
        font-size: 16px;
        color: #9a9a9a;
        margin: 10px auto;
        overflow: hidden;
        white-space: nowrap;
      }
        & .area {
          padding-right: 10px;
          border-right: 1px solid #bfbfbf;
        }
        & .meeting,& .training {
          margin-left: 10px;
        }

      & .info:hover, .info:active {
        color: var(--primary-color);
      }

      & .scope {
        display: block;
        text-align: center;
        margin: 22px auto;
        padding: 5px 10px;
        font-size: 18px;
        line-height: 1;
        color: #6a6a6a;
        background-color: #dfe8f2;
        width: 10em;
        border-radius: 20px;
      }

      & + p {
        width: 950px;
        padding-top: 23px;
        margin: 0 auto;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
        color: $black;
      }
    }

    & .ui-btn {
      width: 220px;
      height: 45px;
      margin: 50px auto 0;
      font-size: 16px;
    }
  }

  @media (max-width: 768px) {
    .service-course {
      padding: 0 0 50px;

      & .sub-title {
        line-height: 18px;
        margin: -3px;
      }

      & .course-list {
        height: 116px;

        & .animation-wrapper .timeline-wrap a .ball {
          bottom: 8px;
        }
      }

      & .operation {
        width: 100%;
        padding: 10px 0 80px;
        /*border-bottom: 1px solid #E6E6E6;*/

        & .prev,
        & .next {
          width: 24px;
          height: 48px;
          position: absolute;
          top: -60px;
          z-index: 99999;

          &:before {
            content: ' ';
            display: block;
            position: absolute;
            left: 0;
            top: 50%;
            width: 24px;
            height: 24px;
            border-top: 2px solid #c8c8c8;
          }

          &:hover:before {
            border-color: #999;
          }
        }

        & .prev {
          &:before {
            transform: translate(8px, -50%) rotate(-45deg);
          }
        }

        & .next {
          &:before {
            transform: translate(-8px, -50%) rotate(45deg);
          }
        }

        &>h6 {
          height: 70px;
          padding-top: 0;
          line-height: 22px;
          font-size: 16px;
        }

        & .info{
          display: flex;
          align-items: center;
          position: relative;
          width: 340px;
          line-height: 1.5;
          font-size: 12px;
          border: 1px solid #bfbfbf;
          border-top: none;
          padding: 5px 10px;
          margin: 0 auto;
          text-align: left;
        }

        & .info .area-info {
          display: flex;
          flex-direction: column;
        }

        & .info > span{
          position: relative;
        }

        & .info:first-of-type {
          margin-top: 20px;
          border-top: 1px solid #bfbfbf;
        }

        & .arrow {
          position: absolute!important;
          top: 50%;
          right: 0;
          transform: translateX(-50%) translateY(-50%);
          width: 3em;
          padding: 0 5px;
          // display: inline-block;
        }

        & .arrow i{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTU0MTE3NzE1ODkzIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE5NjIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNzg3LjIgNTEyYzAtMTIuOC02LjQtMTkuMi0xMi44LTI1LjZMMjk0LjQgNi40QzI4MS42IDAgMjYyLjQgMCAyNDkuNiA2LjRjLTEyLjggMTIuOC0xMi44IDMyIDAgNDQuOEw3MTAuNCA1MTJjMCAwIDAgMCAwIDBsLTQ2MC44IDQ1NC40Yy0xMi44IDEyLjgtMTIuOCAzMiAwIDQ0LjggMTIuOCAxMi44IDMyIDEyLjggNDQuOCAwbDQ4MC00NzMuNmM2LjQtNi40IDYuNC02LjQgNi40LTEyLjhDNzgwLjggNTI0LjggNzg3LjIgNTE4LjQgNzg3LjIgNTEyeiIgcC1pZD0iMTk2MyIgZmlsbD0iI2M4YzhjOCI+PC9wYXRoPjwvc3ZnPg==');
          background-repeat: no-repeat;
          background-size: 50% 50%;
          background-position: 75% center;
          width: 20px;
          height: 20px;
          display: inline-block;
          border-left: 1px solid #bfbfbf;
          margin-left: 20px;
        }

        & + p {
          width: 100%;
          padding-top: 10px;
          line-height: 22px;
          font-size: 12px;
        }
        & .scope {
          font-size: 12px;
          padding: 3px 10px;
        }
      }

      & .ui-btn {
        width: 150px;
        height: 28px;
        margin: 15px auto 0;
        font-size: 12px;
      }
    }
  }

  @media (max-width: 349px) {
    & .info{
      width: 100% !important;
      line-height: 2;
      letter-spacing: -0.1em;
      overflow-x: scroll;
      white-space: nowrap;
      text-align: left;
    }
    & .arrow{
      display: none!important;
    }
  }

  @keyframes loopScale {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    60% {
      opacity: 1;
      transform: scale(0.6);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
</style>
